import React from 'react';
import { motion } from 'framer-motion';
import { MailIcon, SettingsIcon } from 'lucide-react';
export function Support() {
  return <section className="w-full bg-blue-50 py-12 px-4" data-id="element-154">
      <div className="max-w-4xl mx-auto" data-id="element-155">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-156">
          <div className="flex justify-center mb-4" data-id="element-157">
            <div className="bg-blue-100 p-4 rounded-full" data-id="element-158">
              <SettingsIcon className="w-8 h-8 text-blue-600" data-id="element-159" />
            </div>
          </div>
          <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-160">
            ¿Necesitás ayuda?
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-161">
            Nuestro equipo de soporte está disponible para ayudarte
          </p>
          <a href="mailto:EbookDreamShop@gmail.com" className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 font-semibold text-lg transition-colors" data-id="element-162">
            <MailIcon className="w-5 h-5" data-id="element-163" />
            EbookDreamShop@gmail.com
          </a>
        </motion.div>
      </div>
    </section>;
}